import React from 'react';
import Loader from 'src/components/Loader/Loader';

export const LoaderWrapper = ({
  isLoading,
  loader,
  children,
}: {
  isLoading: boolean;
  loader: React.ReactNode;
  children?: React.ReactNode;
}) => {
  return isLoading ? <>{loader || <Loader />}</> : <>{children}</>;
};
